import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Form } from 'antd'

import { TextInput, FormContainer } from 'Shared/Components/FormComponents'
import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import { showSuccess } from 'Shared/Components/NotifyToast'

const TypeForm = ({ mode, type_id, initialState, reload, closemodal }) => {
  const { t } = useTranslation()
  const { send } = useFetchData()
  const [form] = Form.useForm()
  const { setPageLoading } = useOutletContext()

  const onFinish = (value) => {
    const call = async (url, method) => {
      setPageLoading(true)

      const res = await send({
        method: method,
        url: url,
        contentType: "json",
        body: {
          "type_name": value["type_name"],
          "description": value["description"]
        }
      })

      if (res != null) {
        showSuccess(t("general_success"))
        closemodal()
        await reload()
      }

      setPageLoading(false)
    }

    switch (mode) {
      case "create":
        call(`${apiUrl}/assets_tracking/types`, "POST")
        return
      case "edit":
        call(`${apiUrl}/assets_tracking/types/${type_id}`, "PUT")
        return
      default:
        return
    }
  }

  return (<>
    <FormContainer form={form} onFinish={onFinish} initialValues={initialState}>
      <TextInput field_name={t("assetsTracking_equipmentType")} field_id="type_name" required />
      <TextInput field_name={t("assetsTracking_equipmentDescription")} field_id="description" required />
    </FormContainer>
  </>)
}

export default TypeForm
